<template>
  <div class="relative inline-block text-left">
    <button
      class="
        inline-flex w-[242px] items-center justify-between
        rounded-2xl bg-gray-200
        px-3 py-1 text-[15px] text-transparent
        sm:py-3 animate-pulse
      "
    >
      <span class="whitespace-nowrap pr-1 leading-[1.5] tracking-tight text-transparent text-sm sm:text-base">
        &nbsp;
      </span>

      <div class="w-6 h-6 bg-gray-300 rounded-full animate-pulse"></div>
    </button>

    <div
      class="
        absolute right-0 z-50 mt-2 min-w-40 w-full origin-top-right rounded-xl bg-gray-200 shadow-lg animate-pulse
      "
    >
      <div class="py-1">
        <div
          class="
            flex items-center whitespace-nowrap px-4 py-2 leading-[1.5] tracking-tight text-transparent sm:text-base
          "
        >
          <div class="mr-3 w-6 h-6 bg-gray-300 rounded-full animate-pulse"></div>
          <span class="block w-20 h-6 bg-gray-300 rounded"></span>
        </div>
      </div>
    </div>
  </div>
</template>
